
import { Auth } from "./auth.js";
import { escapeHtml } from "./utils.js";
/**
 * Efast Workbench - 用户管理
 * 从 sales_logic.js 拆分
 */

window._aliasMapCache = null;

function initUserManagement() {
    const role = Auth.getRole(); if (role === 'boss' || role === 'supervisor') {
        document.querySelectorAll('.boss-only').forEach(el => el.classList.add('visible'));
        loadUserList();
    }
}

async function loadUserList() {
    const tbody = document.getElementById('user-table-body');
    const errEl = document.getElementById('user-mgmt-error');
    if (!tbody) return;

    try {
        const data = await Auth.apiFetch('/api/users');
        tbody.innerHTML = data.users.map(u => `
            <tr>
                <td style="font-weight:bold;">${escapeHtml(u.username)}</td>
                <td>${escapeHtml(u.displayName)}</td><td><span style="color:var(--text-muted);font-size:0.8rem;">${escapeHtml(u.alibabaAlias || "")}</span></td>
                <td><span class="role-badge ${u.role}">${roleLabel(u.role)}</span></td>
                <td>${escapeHtml(u.title)}</td>
                <td style="color:var(--text-muted);">****</td>
                <td>
                    <button class="btn-sm btn-edit" onclick="showChangePasswordModal('${escapeHtml(u.username)}')" title="修改密码">
                        <i class="fa-solid fa-key"></i>
                    </button>
                    ${u.role !== 'boss'
                        ? `<button class="btn-sm btn-edit" onclick="showEditAliasModal('${escapeHtml(u.username)}', '${escapeHtml(u.alibabaAlias || "")}')" title="编辑别名" style="margin-right:4px;"><i class="fa-solid fa-tag"></i> 别名</button> <button class="btn-delete-user" onclick="deleteUser('${escapeHtml(u.username)}')"><i class="fa-solid fa-trash"></i> 删除</button>`
                        : `<span style="color:var(--text-muted);font-size:0.75rem;">不可删除</span>`}
                </td>
            </tr>
        `).join('');
        if (errEl) errEl.style.display = 'none';
    } catch (e) {
        if (errEl) {
            errEl.style.display = 'block';
            errEl.textContent = '加载用户列表失败: ' + e.message;
        }
    }
}

function roleLabel(role) {
    const map = { boss: '总经理', manager: '经理', supervisor: '超级管理员', salesperson: '业务员' };
    return map[role] || role;
}

function showAddUserForm() {
    const modal = document.getElementById('user-form-modal');
    const title = document.getElementById('user-form-title');
    const errEl = document.getElementById('user-form-error');
    if (!modal) return;
    modal.style.display = 'flex';
    if (title) title.innerHTML = '<i class="fa-solid fa-user-plus"></i> 添加用户';
    if (errEl) errEl.style.display = 'none';
    ['uf-username','uf-password','uf-displayname','uf-alias','uf-title'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.value = '';
    });
    const roleEl = document.getElementById('uf-role');
    if (roleEl) roleEl.value = 'salesperson';
}

function closeUserForm() {
    const modal = document.getElementById('user-form-modal');
    if (modal) modal.style.display = 'none';
}

async function submitUserForm() {
    const username = document.getElementById('uf-username').value.trim();
    const password = document.getElementById('uf-password').value.trim();
    const displayName = document.getElementById('uf-displayname').value.trim();
    const title = document.getElementById('uf-title').value.trim();
    const alibabaAlias = document.getElementById('uf-alias').value.trim();
    const role = document.getElementById('uf-role').value;
    const errEl = document.getElementById('user-form-error');

    if (!username || !password || !displayName) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = '用户名、密码、姓名为必填'; }
        return;
    }

    try {
        await Auth.apiFetch('/api/users', {
            method: 'POST',
            body: JSON.stringify({ username, password, displayName, role, title, alibabaAlias })
        });
        closeUserForm();
        loadUserList();
    } catch (e) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = e.message; }
    }
}

async function deleteUser(username) {
    if (!confirm('确定删除用户 "' + username + '" 吗？此操作不可撤销。')) return;
    const errEl = document.getElementById('user-mgmt-error');
    try {
        await Auth.apiFetch('/api/users/' + encodeURIComponent(username), { method: 'DELETE' });
        loadUserList();
    } catch (e) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = '删除失败: ' + e.message; }
    }
}


// 编辑用户阿里别名弹窗
function showEditAliasModal(username, currentAlias) {
    const alias = prompt("请输入用户 \"" + username + "\" 的阿里英文别名（如 Samantha Li）：", currentAlias || "");
    if (alias === null) return; // 用户取消
    Auth.apiFetch("/api/users/" + encodeURIComponent(username), {
        method: "PUT",
        body: JSON.stringify({ alibabaAlias: alias.trim() })
    }).then(function() {
        loadUserList();
    }).catch(function(e) {
        alert("别名更新失败: " + e.message);
    });
}

// 阿里别名 → 系统 displayName 映射
var _aliasMapCache = null;
window.mapAliasToDisplayName = mapAliasToDisplayName;
async function mapAliasToDisplayName(alias) {
    if (!alias) return alias;
    // 懒加载：首次调用时从服务端拉取用户列表并缓存
    if (!_aliasMapCache) {
        try {
            var data = await Auth.apiFetch("/api/users/aliases");
            _aliasMapCache = {};
            Object.keys(data.aliases).forEach(function(alias) {
                _aliasMapCache[alias] = data.aliases[alias];
            });
        } catch (e) {
            console.error("[Efast Map] 加载别名映射失败:", e);
            return alias;
        }
    }
    return _aliasMapCache[alias] || alias;
}
function showChangePasswordModal(username) {
    const modal = document.getElementById('password-modal');
    const usernameInput = document.getElementById('pw-username');
    const errEl = document.getElementById('password-form-error');
    if (!modal) return;
    
    usernameInput.value = username;
    document.getElementById('pw-new-password').value = '';
    document.getElementById('pw-confirm-password').value = '';
    if (errEl) errEl.style.display = 'none';
    modal.style.display = 'flex';
}

function closePasswordModal() {
    const modal = document.getElementById('password-modal');
    if (modal) modal.style.display = 'none';
}

async function submitPasswordChange() {
    const username = document.getElementById('pw-username').value;
    const newPassword = document.getElementById('pw-new-password').value;
    const confirmPassword = document.getElementById('pw-confirm-password').value;
    const errEl = document.getElementById('password-form-error');

    if (!newPassword || !confirmPassword) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = '请输入新密码和确认密码'; }
        return;
    }

    if (newPassword !== confirmPassword) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = '两次输入的密码不一致'; }
        return;
    }

    if (newPassword.length < 6) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = '密码长度不能少于6位'; }
        return;
    }

    try {
        await Auth.apiFetch('/api/users/' + encodeURIComponent(username) + '/password', {
            method: 'PUT',
            body: JSON.stringify({ password: newPassword })
        });
        closePasswordModal();
        alert('密码修改成功');
    } catch (e) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = e.message; }
    }
}





// window bridges for template onclick handlers
window.showAddUserForm = showAddUserForm;
window.closeUserForm = closeUserForm;
window.submitUserForm = submitUserForm;
window.closePasswordModal = closePasswordModal;
window.submitPasswordChange = submitPasswordChange;
window.showChangePasswordModal = showChangePasswordModal;

window.deleteUser = deleteUser;
window.showEditAliasModal = showEditAliasModal;
export { initUserManagement, loadUserList };
